<script>
import EggOrderAdd from '@/sales/components/EggOrderAdd.vue';
export default {
  components: {
    EggOrderAdd,
  },

  methods: {
    onOrderAdded(order) {
      this.$router.push({ name: 'sales/egg-order/by-id', params: { id: order.id } })
    },
  },
}
</script>

<template>
  <b-card>
    <egg-order-add @added="onOrderAdded" />
  </b-card>
</template>



// WEBPACK FOOTER //
// src/sales/views/EggOrderAddView.vue